import { makeStyles, tokens, typographyStyles } from "@fluentui/react-components"

import { DetailsSectionState } from "./DetailsSection.types";

export const useStyles = makeStyles({
  container: {
    // paddingLeft: tokens.spacingHorizontalS
  },
  heading: {
    //TODO(nibeauli): detect if we are h1 vs h2/3/4/5/6 etc
    ...typographyStyles.subtitle2,
    marginBottom: 0,
  },
  description: {
    ...typographyStyles.caption1,
    marginBottom: tokens.spacingVerticalM,
    color: tokens.colorNeutralForeground3
  }
})

export function applyStyles(state: DetailsSectionState): void {
  const classes = useStyles();
  state.root.className = classes.container;
  state.heading.className = classes.heading;
  state.description.className = classes.description;
}
